<script lang="ts">
  import type { Snippet } from 'svelte';
  import type { Route } from '../../stores/router';
  import Breadcrumb from './Breadcrumb.svelte';

  interface Props {
    title: string;
    description?: string;
    breadcrumbs: { label: string; route?: Route }[];
    content: Snippet;
    sidebar?: Snippet;
  }

  let { title, description, breadcrumbs, content, sidebar }: Props = $props();
</script>

<div class="min-h-screen bg-bg-dark text-text-primary">
  <div class="w-full px-6 py-4">
    <!-- Breadcrumb -->
    <Breadcrumb items={breadcrumbs} />

    <!-- Header -->
    <div class="mt-4 mb-6">
      <h1 class="text-2xl font-bold text-text-primary">{title}</h1>
      {#if description}
        <p class="mt-1 text-sm text-text-secondary">{description}</p>
      {/if}
    </div>

    <!-- Content area -->
    {#if sidebar}
      <div class="flex gap-6">
        <div class="flex-1 min-w-0">
          {@render content()}
        </div>
        <aside class="w-80 shrink-0">
          {@render sidebar()}
        </aside>
      </div>
    {:else}
      {@render content()}
    {/if}
  </div>
</div>
